import markdownit from 'markdown-it'
import Bubble from '../bubble'
import { MarkdownMessageType, CommonMsgNodeProps } from '@/types/message'

const md = markdownit({ html: true, breaks: true })

interface MarkdownWidgetProps extends CommonMsgNodeProps {
  node: MarkdownMessageType
}

const renderMarkdown: any = content => {
  return (
    <div
      style={{
        color: '#333',
        fontSize: '14px',
        fontWeight: 500
      }}
      dangerouslySetInnerHTML={{ __html: md.render(content) }}
    />
  )
}

const MarkdownWidget = (props: MarkdownWidgetProps) => {
  const { node, useTypingComplete = false, onTypingComplete } = props
  const { display = 'block' } = node

  const isBlockLayout = display === 'block'
  const _value: any = node?.value
  const value = typeof _value === 'string' ? _value : _value?.text

  return (
    <div
      className="y-justify-start y-text-gray-700 y-text-14 y-font-semibold y-mt-5"
      style={{
        display: isBlockLayout ? 'flex' : 'inline-flex'
      }}
    >
      <Bubble
        onTypingComplete={onTypingComplete}
        typing={useTypingComplete}
        content={value || ''}
        messageRender={renderMarkdown}
      />
    </div>
  )
}

export default MarkdownWidget
